<template>
  <div>
    <span>{{ row.airplane }}</span>
    <template v-if="row.airplane2 && row.airplane2 !== row.airplane">
      <hr style="border-top: dashed rgba(80%, 80%, 80%, 0.5) 1px;" class="my-0" />
      <span>{{ row.airplane2 }}</span>
    </template>
  </div>
</template>

<script>

export default {
  name: 'CalcFlightsTableCellAirplane',
  props: {
    row: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellAirplane.vue